module.exports = __webpack_public_path__ + "media/customizations/cypressgreenlife/logo-93168fb3bcd71dbcfff4e9dfe91b52ce.png";